import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.'}
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.'}
      ]
    },
    ClientName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Please fill in required field.'}
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.'},
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    CellNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    }, 
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    Theme: {
      validations: []
    },
    EventExtra1: {
      validations: []
    },
    EventExtra2: {
      validations: []
    },
    EventExtra3: {
      validations: []
    },
    EventExtra4: {
      validations: []
    },
    AccountExtra1: {
      validations: []
    },
    AccountExtra2: {
      validations: []
    },   
    Notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName'
          },{
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Organization *',
            mapping: 'ClientName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'TelNumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Cell Number',
            mapping: 'CellNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Anticipated Number of Guest',
            mapping: 'PlannedGuestCount'
          },
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'EventDate'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type',
            options: [
              { label: 'Auction/Fundraiser' , value: 'Auction/Fundraiser'},
              { label: 'Banquet/Reception', value: 'Banquet/Reception'},
              { label: 'Meeting/presentation', value: 'Meeting/presentation'},
              { label: 'Networking', value: 'Networking' },
              { label: 'Celebration', value: 'Celebration' },
              { label: 'Field Use', value: 'Field Use' },
              { label: 'Concourse', value: 'Concourse' },
              { label: 'Community Event', value: 'Community Event' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Are you familiar with the spaces?',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' }
            ],
            mapping: 'EventExtra1'
          },
          
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Audio/Visual Needs',
            options: [
              { label: 'Mic/Speakers', value: 'Mic/Speakers' },
              { label: 'Staging', value: 'Staging' },
              { label: 'Lighting', value: 'Lighting' },
              { label: 'Presentation', value: 'Presentation' },
              { label: 'Unknown', value: 'Unknown' }
            ],
            mapping: 'EventExtra2'
          },
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Food & Beverage Needs',
            options: [
              { label: 'Breakfast', value: 'Breakfast' },
              { label: 'Lunch', value: 'Lunch' },
              { label: 'Dinner', value: 'Dinner' },
              { label: 'Bar Service', value: 'Bar Service' }
            ],
            mapping: 'EventExtra3'
          },
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Enhancements',
            options: [
              { label: 'Tours', value: 'Tours'},
              { label: 'Mascot Apperamce' , value: 'Mascot Apperamce'},
              { label: 'Video Board Message', value: 'Video Board Message'},
              { label: 'Batting Cages', value: 'Batting Cages'},
              { label: 'Walk the Bases', value: 'Walk the Bases' },
            ],
            mapping: 'EventExtra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Space Interested in',
            options: [
              { label: 'YG Club', value: 'YG Club' },
              { label: 'Conference Room', value: 'Conference Room' },
              { label: 'Batting Cages', value: 'Batting Cages' },
              { label: 'Aetna Community Center', value: 'Aetna Community Center' },
              { label: 'Suites', value: 'Suites' },
              { label: 'Concourse', value: 'Concourse' },
              { label: 'Field', value: 'Field' },
              { label: 'Clubhouse', value: 'Clubhouse' },
              { label: 'Unsure', value: 'Unsure'},
            ],
            mapping: 'AccountExtra1'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Additional Contact Name',
            mapping: 'AccountExtra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Notes/Comments',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Hartford Yard Goats Contact Form',
    formId: '448',
    clientKey: 'C70C0760-3440-4EE2-A5A4-7B2125BC201B',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/web_inquiry/inquiry-renderer/client_forms/hartfordyardgoats/form_structure.js